<template>
  <footer id="footer" class="site-footer">
    <div class="site-footer-inner">
      <div class="site-footer-brand">
        <router-link :to="{ name: 'inicio' }" aria-label="Ir al inicio">
          <img :src="require('@/assets/img/logo_santo_domingo_dark.png')" :alt="nombreSitio" />
        </router-link>
        <p>{{ nombreSitio }}</p>
      </div>

      <nav class="site-footer-col" aria-label="Enlaces del pie">
        <h2>Navegación</h2>
        <ul>
          <li><router-link :to="{ name: 'inicio' }">Inicio</router-link></li>
          <li><router-link :to="{ name: 'vistaNoticias' }">Noticias</router-link></li>
          <li><router-link :to="{ name: 'Eventos' }">Calendario de eventos</router-link></li>
          <li><router-link :to="{ name: 'Multimedia' }">Galería</router-link></li>
          <li><router-link :to="{ name: 'CaritasParroquialNoticias' }">Cáritas parroquial</router-link></li>
          <li v-if="visible('caritasColabora')"><router-link :to="{ name: 'caritasColabora' }">Colabora con Cáritas</router-link></li>
          <li v-if="visible('historia')"><router-link :to="{ name: 'historia' }">Historia y patrimonio</router-link></li>
          <li v-if="visible('sanJudas')"><router-link :to="{ name: 'sanJudas' }">San Judas Tadeo</router-link></li>
        </ul>
      </nav>

      <div class="site-footer-col">
        <h2>Contacto</h2>
        <ul class="site-footer-contact">
          <li v-if="tlfIglesia">
            <span class="material-symbols-outlined">call</span>
            <a v-track:contacto="{ metodo: 'telefono', origen: 'pie' }" :href="`tel:${tlfIglesia}`">{{ telefonoFormateado }}</a>
          </li>
          <li v-if="mailIglesia">
            <span class="material-symbols-outlined">mail</span>
            <a v-track:contacto="{ metodo: 'email', origen: 'pie' }" :href="`mailto:${mailIglesia}`">{{ mailIglesia }}</a>
          </li>
          <li v-if="direccion">
            <span class="material-symbols-outlined">location_on</span>
            <a v-track:contacto="{ metodo: 'mapa', origen: 'pie' }" :href="mapsUrl" target="_blank" rel="noopener">{{ direccion }}</a>
          </li>
        </ul>
      </div>

      <div class="site-footer-col">
        <h2>Síguenos</h2>
        <ul class="site-footer-contact">
          <li v-if="avisos.estado !== 'no-soportado'">
            <span class="material-symbols-outlined">{{ avisos.estado === "activos" ? "notifications_active" : "notifications" }}</span>
            <button
              v-if="avisos.estado === 'inactivos'"
              type="button"
              class="site-footer-btn"
              :disabled="avisos.trabajando"
              @click="activarAvisos('pie').catch(() => {})"
            >
              Activar avisos en el móvil
            </button>
            <span v-else-if="avisos.estado === 'activos'" class="site-footer-text">Avisos activados</span>
            <router-link v-else :to="{ name: 'inicio', hash: '#titulo-informado' }">Avisos en el móvil</router-link>
          </li>
          <li>
            <span class="material-symbols-outlined">forum</span>
            <a v-if="canalWhatsapp" :href="canalWhatsapp" target="_blank" rel="noopener" v-track:seguir_whatsapp="{ origen: 'pie' }">Canal de WhatsApp</a>
            <span v-else class="site-footer-text site-footer-text--muted">Canal de WhatsApp · próximamente</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="site-footer-bottom">
      <div class="site-footer-bottom-inner">
        <p>© {{ year }} {{ nombreSitio }}</p>
        <button type="button" class="site-footer-cookies" @click="abrirPanelCookies">
          <span class="material-symbols-outlined">cookie</span> Configurar cookies
        </button>
      </div>
    </div>
  </footer>
</template>

<script>
import { Constantes } from "@/directives/Constantes";
import { abrirPanelCookies } from "@/directives/analitica.js";
import { estadoAvisos, activarAvisos } from "@/directives/avisosPush.js";
import { paginaVisible, CANAL_WHATSAPP } from "@/contenido/config.js";

export default {
  name: "footer-site",
  methods: {
    abrirPanelCookies,
    activarAvisos,
    visible: paginaVisible,
  },
  data() {
    return {
      mailIglesia: Constantes.email.iglesia,
      tlfIglesia: Constantes.tlf.iglesia,
      direccion: (Constantes.direccion || "").trim(),
      nombreSitio: Constantes.nombre_sitio,
      year: new Date().getFullYear(),
      avisos: estadoAvisos,
      canalWhatsapp: CANAL_WHATSAPP,
    };
  },
  computed: {
    telefonoFormateado() {
      const m = (this.tlfIglesia || "").match(/^(\+34)(\d{3})(\d{2})(\d{2})(\d{2})$/);
      return m ? `${m[1]} ${m[2]} ${m[3]} ${m[4]} ${m[5]}` : this.tlfIglesia;
    },
    mapsUrl() {
      return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(this.direccion);
    },
  },
};
</script>

<style scoped>
.site-footer {
  position: relative;
  background: #0d1b30;
  color: rgba(255, 255, 255, 0.72);
  text-align: left;
  font-family: var(--sd-font-body);
}

.dark .site-footer {
  background: #060c18;
  border-top: 1px solid #1e293b;
}

.site-footer-inner {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(0, 1fr) minmax(0, 1.2fr) minmax(0, 1fr);
  gap: 40px;
  max-width: 1280px;
  margin: 0 auto;
  padding: 56px 20px 40px;
}

.site-footer-brand img {
  width: 260px;
  max-width: 100%;
}

.site-footer-brand p {
  max-width: 320px;
  margin: 16px 0 0;
  font-size: 0.9rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.6);
}

.site-footer-col h2 {
  margin: 0 0 16px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #e3c47e;
}

.site-footer-col ul {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.site-footer a {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  transition: color 0.15s;
}

.site-footer a:hover {
  color: #fff;
  text-decoration: underline;
}

.site-footer-contact li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.site-footer-contact .material-symbols-outlined {
  flex-shrink: 0;
  font-size: 20px;
  color: #e3c47e;
}

.site-footer-contact a {
  word-break: break-word;
}

.site-footer-btn {
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  color: rgba(255, 255, 255, 0.85);
  text-align: left;
  cursor: pointer;
}

.site-footer-btn:hover {
  color: #fff;
  text-decoration: underline;
}

.site-footer-text {
  color: rgba(255, 255, 255, 0.85);
}

.site-footer-text--muted {
  color: rgba(255, 255, 255, 0.55);
}

.site-footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.site-footer-bottom-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 20px;
  max-width: 1280px;
  margin: 0 auto;
  padding: 18px 20px;
}

.site-footer-bottom p {
  margin: 0;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.5);
}

.site-footer-cookies {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: 0;
  background: none;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
}

.site-footer-cookies:hover {
  color: #fff;
  text-decoration: underline;
}

.site-footer-cookies .material-symbols-outlined {
  font-size: 16px;
  color: #e3c47e;
}

@media (max-width: 1100px) {
  .site-footer-inner {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .site-footer-brand {
    grid-column: 1 / -1;
  }
}

@media (max-width: 860px) {
  .site-footer-inner {
    grid-template-columns: 1fr 1fr;
  }

  .site-footer-brand {
    grid-column: 1 / -1;
  }
}

@media (max-width: 520px) {
  .site-footer-inner {
    grid-template-columns: 1fr;
    gap: 32px;
    padding-top: 44px;
  }
}
</style>
